export default __webpack_public_path__ + "85dc6c184284a8ae9a21a236c2e5ff0b.svg";